'use client';

import React from 'react';
import Link from 'next/link';
import { OutlineButtonProps } from './types';
import {
  StyledAnchorOutline,
  StyledButtonOutline,
  StyledLinkOutline,
} from './styles';

const OutlineButton: React.FC<OutlineButtonProps> = ({
  link,
  action,
  children,
  anchorComponent = StyledAnchorOutline,
  buttonComponent = StyledButtonOutline,
  linkComponent = StyledLinkOutline,
  actionType, // 👈 consume it so it never reaches DOM
  theme,
  ...rest
}) => {
  // 👇 explicitly remove non-DOM props that might still be in rest
  const {
    actionType: _a,
    theme: _t,
    link: _l,
    action: _ac,
    buttonComponent: _bc,
    linkComponent: _lc,
    anchorComponent: _anc,
    ...safeProps
  } = rest as Record<string, any>;

  if (link) {
    return (
      <Link href={link}>
        <StyledLinkOutline {...safeProps}>{children}</StyledLinkOutline>
      </Link>
    );
  }

  if (action) {
    return (
      <StyledButtonOutline onClick={action} {...safeProps}>
        {children}
      </StyledButtonOutline>
    );
  }

  return <StyledAnchorOutline {...safeProps}>{children}</StyledAnchorOutline>;
};

export default OutlineButton;
